module.exports = __webpack_public_path__ + "14four/static/media/Hoop.d3c3aa7b.png";